import React from 'react'

/**
 * Hjälpare för mjukt tangentbord på surfplatta.
 *
 * Två problem uppstår när iOS-tangentbordet fälls upp, och båda kommer av att
 * tangentbordet INTE krymper layout-viewporten i Safari. Sidan tror att den är lika
 * hög som förut, medan den synliga ytan är halverad.
 */

/**
 * Scrollar det fokuserade fältet till mitten av den synliga ytan.
 *
 * iOS scrollar visserligen självt fram ett fokuserat fält, men räknar med hela
 * layout-viewporten. Ligger fältet nära nederkanten – som anteckningsrutan gör,
 * strax ovanför knappraden – hamnar det bakom tangentbordet.
 *
 * Fördröjningen finns för att tangentbordets uppfällning tar ungefär en kvarts
 * sekund; scrollar man direkt räknar webbläsaren på den gamla ytan.
 */
export const scrollaInIVy = (e: React.FocusEvent<HTMLElement>) => {
  const el = e.currentTarget
  window.setTimeout(() => el.scrollIntoView({ block: 'center', behavior: 'smooth' }), 300)
}

/**
 * Hindrar att ett fokuserat fält tappar fokus innan knappens klick hunnit registreras.
 *
 * På iOS är ordningen touchend → mousedown → blur → click. Blur fäller ned
 * tangentbordet, sidan flödar om, och knappen hinner flytta sig innan click når den –
 * resultatet blir att första trycket bara stänger tangentbordet. Genom att avbryta
 * mousedown behåller fältet fokus, ingen omflödning sker, och klicket landar.
 *
 * Läggs på knappar som kan tryckas medan ett fält är fokuserat.
 */
export const behallFokus = (e: React.MouseEvent<HTMLElement>) => {
  e.preventDefault()
}
